<template>
  <base-section
  id="call-for-papers"
  >
    <v-container>
    <base-section-heading
    title="Preliminary Call for Papers"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <p>
      We are pleased to announce the <strong>Preliminary Call for Papers</strong> for the
      <strong>28th IEEE Latin-American Test Symposium (LATS 2027)</strong>, to be held in
      <strong>Lima, Peru, April 13–16, 2027</strong>.
    </p>
    <p>
      Download the Preliminary Call for Papers document for full details on topics of interest,
      submission guidelines, and important dates.
    </p>
    <v-btn
        href="LATS27_cfp.pdf"
        rounded
        color="primary"
        dark
        download
        style="padding: 10px 15px; white-space: normal; height: auto; max-width: 100%;"
    >
        <v-icon left dark>mdi-cloud-download</v-icon>
        Download Preliminary Call for Papers
    </v-btn>
    <br /><br />
    <p>
      Papers must be submitted through the official submission website:
      <a href="https://easychair.org/conferences/?conf=lats2027" target="_blank" rel="noopener noreferrer">
        https://easychair.org/conferences/?conf=lats2027
      </a>
    </p>
    <v-btn
        href="https://easychair.org/conferences/?conf=lats2027"
        target="_blank"
        rel="noopener noreferrer"
        rounded
        color="primary"
        dark
        style="padding: 10px 15px; white-space: normal; height: auto; max-width: 100%;"
    >
        <v-icon left dark>mdi-upload</v-icon>
        Submit Paper
    </v-btn>
    </base-section-heading>
    <base-section-heading
    title="Key Dates"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
Submission Deadline (Title and Abstract): <span style="color: #6663A6"><strong>November 6th, 2026</strong></span><br />
Submission Deadline (Full Paper): <span style="color: #6663A6"><strong>November 13th, 2026</strong></span><br />
Notification of Acceptance: <span style="color: #6663A6"><strong>January 11th, 2027</strong></span><br />
Camera Ready: <span style="color: #6663A6"><strong>January 25th, 2027</strong></span><br />
</strong>
    </base-section-heading>

    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'CallForPapers',

    data: () => ({
      features: [
        {
          title: 'Pixel Perfect Design',
          icon: 'mdi-fountain-pen-tip',
        },
        {
          title: 'Retina Ready',
          icon: 'mdi-cellphone',
        },
        {
          color: 'primary',
          dark: true,
          title: 'Easily Customizable',
          icon: 'mdi-pencil-box-outline',
        },
        {
          title: 'Image Parallax',
          icon: 'mdi-image-size-select-actual',
        },
        {
          title: 'Seo Optimized',
          icon: 'mdi-ice-pop',
        },
        {
          title: '24/7 Support',
          icon: 'mdi-help-circle-outline',
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
</style>
